import { rem, type SegmentedControlProps } from "@mantine/core";
import { brandColorTokens } from "./brandColorTokens";
import type { CSSProperties } from "react";

/** L1-only CSS variables for grouped participant light surfaces (join, prioritize, submitted). */
export const participantLightCssVars: CSSProperties = {
  ["--participant-light-page-bg" as string]: brandColorTokens.facilitatorMainContentPaper,
  ["--participant-light-paper-bg" as string]: brandColorTokens.facilitatorSidebarBackground,
  ["--participant-light-join-paper-bg" as string]: brandColorTokens.facilitatorSidebarNavActive,
  ["--participant-light-card-bg" as string]: brandColorTokens.facilitatorSidebarBackground,
  ["--participant-light-heading" as string]: brandColorTokens.facilitatorPageHeading,
  ["--participant-light-body" as string]: brandColorTokens.facilitatorSidebarNavActiveText,
  ["--participant-light-muted" as string]: brandColorTokens.facilitatorPageSubtitle,
  ["--participant-light-card-border" as string]: `color-mix(in srgb, ${brandColorTokens.facilitatorSectionTileActive} 35%, transparent)`,
  ["--participant-light-card-border-expanded" as string]: brandColorTokens.facilitatorSectionTileActive,
  ["--participant-light-cta-bg" as string]: brandColorTokens.facilitatorPrimaryCta,
  ["--participant-light-cta-text" as string]: brandColorTokens.facilitatorPrimaryCtaText,
  ["--participant-light-tab-active-bg" as string]: brandColorTokens.facilitatorSectionTileActive,
  ["--participant-light-tab-active-border" as string]: brandColorTokens.facilitatorSectionTileActive,
  ["--participant-light-tab-active-text" as string]: brandColorTokens.facilitatorTextOnDark,
  ["--participant-light-prioritize-bg" as string]: brandColorTokens.facilitatorSidebarNavActive,
  ["--participant-light-prioritize-text" as string]: brandColorTokens.facilitatorSidebarNavActiveText,
};

/** Coral primary CTA on grouped participant flows (coral 400 / #FFB8A6). */
export const participantLightPrimaryButtonStyles = {
  root: {
    backgroundColor: brandColorTokens.facilitatorPrimaryCta,
    color: brandColorTokens.facilitatorPrimaryCtaText,
  },
} as const;

/** Light text on the dark selected pill. `--sc-label-color` is what Mantine’s active-label CSS reads. */
export const groupedTabActiveLabelColor = brandColorTokens.facilitatorTextOnDark;

export const questionGroupSegmentedControlStyles: SegmentedControlProps["styles"] = {
  root: {
    backgroundColor: brandColorTokens.facilitatorSidebarNavActive,
    padding: rem(4),
    "--sc-label-color": groupedTabActiveLabelColor,
  },
  indicator: {
    backgroundColor: brandColorTokens.facilitatorSectionTileActive,
    border: `${rem(2)} solid ${brandColorTokens.facilitatorSectionTileActive}`,
    boxShadow: "none",
  },
  innerLabel: {
    color: "inherit",
  },
};
